/** @type {import("tinymce").RawEditorSettings} */
const commonConfig = {
	menubar: false,
	branding: true,
	formats: {
		bold: {
			inline: "strong",
		},
		underline: {
			inline: "u",
		},
		strikethrough: {
			inline: "strike",
		},
		removeformat: [
			{
				selector:
					"b,strong,em,i,font,u,strike,s,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins,small",
				remove: "all",
				split: true,
				block_expand: true,
				expand: false,
				deep: true,
			},
			{
				selector: "span",
				attributes: ["style", "class"],
				remove: "empty",
				split: true,
				expand: false,
				deep: true,
			},
			{
				selector: "*",
				attributes: ["style", "class"],
				split: false,
				expand: false,
				deep: true,
			},
		],
	},
	images_upload_handler: (blobInfo, success, failure) =>
		imageUploadHandler(blobInfo)
			.then(success)
			.catch((error) =>
				failure(error.message, { remove: error.remove === true }),
			),
	extended_valid_elements: "b/strong,i/em,u,strike",
};

function additionalMceStylesheetPath() {
	const senaryonStylesheets = _.map(
		$("head").find('link[rel="stylesheet"]'),
		(linkEl) => {
			if ($(linkEl).attr("href")?.includes("/assets/")) {
				return $(linkEl).attr("href");
			}
		},
	);

	return _.filter(senaryonStylesheets, (href) => {
		return href !== undefined;
	}).join(", ");
}

/**
 * @param {{ blob: () => Blob, filename: () => string }} blobInfo
 * @returns {Promise<string>} the uploaded image location URL
 */
async function imageUploadHandler(blobInfo) {
	const csrfTokenName = $('meta[name="csrf-param"]').attr("content"),
		csrfToken = $('meta[name="csrf-token"]').attr("content"),
		$targetElem = $(tinyMCE.activeEditor.targetElm),
		assetableId =
			$targetElem.data("recordId") ||
			$targetElem.parent().find("input.j-fake-id-field").attr("value") ||
			$targetElem
				.closest("div.RtfInfoFields")
				.find("input.j-fake-id-field")
				.attr("value"),
		assetableType = $targetElem.data("recordClass");

	const formData = new FormData();
	formData.append("file", blobInfo.blob(), blobInfo.filename());
	formData.append("assetable_type", assetableType);
	formData.append("assetable_id", assetableId);
	// @ts-expect-error
	formData.append(csrfTokenName, csrfToken);

	let response;
	try {
		response = await fetch("/tinymce/images", {
			method: "POST",
			body: formData,
		});
	} catch (e) {
		throw new Error(`Image upload failed due to a transport error: ${e}`);
	}

	if (response.status === 403) {
		const error = new Error(`HTTP Error: ${response.status}`);
		// @ts-expect-error TinyMCE reads `remove` to discard the uploaded image
		error.remove = true;
		throw error;
	}

	if (!response.ok) {
		throw new Error(`HTTP Error: ${response.status}`);
	}

	const text = await response.text();
	let json;
	try {
		json = JSON.parse(text);
	} catch {
		throw new Error(`Invalid JSON: ${text}`);
	}

	if (!json || typeof json.location !== "string") {
		throw new Error(`Invalid JSON: ${text}`);
	}

	return json.location;
}

const styleFormats = [
	{
		title: "Headings",
		items: [
			{ title: "h1", format: "h1" },
			{ title: "h2", format: "h2" },
			{ title: "h3", format: "h3" },
			{ title: "h4", format: "h4" },
		],
	},
	{
		title: "Blocks",
		items: [
			{ title: "Paragraph", format: "p" },
			{ title: "Blockquote", format: "blockquote" },
			{ title: "Code", format: "code" },
		],
	},
];

const styleFormatsMinimal = [
	{ title: "Paragraph", format: "p" },
	{ title: "h1", format: "h1" },
	{ title: "h2", format: "h2" },
	{ title: "h3", format: "h3" },
	{ title: "h4", format: "h4" },
];

const colors = ["FFFFFF", "White"];
const tableBorderColors = [];
const tableBackgroundColors = [];

const cssColorsToImport = {
	".Chart__tooltip_part-0": "Dark Gray",
	".bg-theme-dark-l3": "Gray",
	".bg-theme-light-d2": "Light Gray",
	".bg-theme-action-l2": "Light Blue",
	".bg-theme-action-d1": "Blue",
};
const parkPastelCount = 13;
for (let i = 0; i < parkPastelCount; i++) {
	cssColorsToImport[`dark-pastel-${i + 1}-bg`] = `dark-pastel-${i + 1}`;
}
const tableBorderColorsToImport = {
	".bg-theme-dark-l3": "Gray",
	".bg-theme-light-d2": "Light Gray",
};
const tableBackgroundColorsToImport = {
	".bg-theme-action-d5": "Dark Blue",
	".popover-action": "Blue",
	".bg-theme-action-l5": "Light Blue",
	".circle-online": "Green",
	".bg-theme-dark-l3": "Gray",
	".bg-theme-light-d2": "Light Gray",
};
$(document).ready(() => {
	Object.entries(cssColorsToImport).forEach(
		([cssSelectorName, mceColorDescriptor]) => {
			colors.push(
				pp.viewHelpers.detectCssRuleFor(cssSelectorName, "background-color"),
				mceColorDescriptor,
			);
		},
	);
	Object.entries(tableBorderColorsToImport).forEach(
		([cssSelectorName, mceColorDescriptor]) => {
			tableBorderColors.push({
				title: mceColorDescriptor,
				value: pp.viewHelpers.detectCssRuleFor(
					cssSelectorName,
					"background-color",
				),
			});
		},
	);

	Object.entries(tableBackgroundColorsToImport).forEach(
		([cssSelectorName, mceColorDescriptor]) => {
			tableBackgroundColors.push({
				title: mceColorDescriptor,
				value: pp.viewHelpers.detectCssRuleFor(
					cssSelectorName,
					"background-color",
				),
			});
		},
	);
});

const tableBorderWidth = [
	{ title: "0px", value: "0px" },
	{ title: "1px", value: "1px" },
	{ title: "2px", value: "2px" },
	{ title: "3px", value: "3px" },
];

const tableBorderStyles = [
	{ title: "Solid", value: "solid" },
	{ title: "Dotted", value: "dotted" },
	{ title: "None", value: "hidden" },
];

const menuBase = {
	edit: {
		title: "Edit",
		items: "undo redo | cut copy paste pastetext | selectall | searchreplace",
	},
	format: {
		title: "Format",
		items:
			"bold italic underline strikethrough superscript subscript | forecolor backcolor | removeformat",
	},
	view: {
		title: "View",
		items: "code preview",
	},
};

const defaultMenu = {
	...menuBase,
	insert: {
		title: "Insert",
		items: "inserttable link quizlink image media",
	},
};

const defaultMenuWithoutQuizlinkAndKbModuleLink = {
	...menuBase,
	insert: {
		title: "Insert",
		items: "inserttable link image media",
	},
};

const defaultMenuWithKbModuleLink = {
	...menuBase,
	insert: {
		title: "Insert",
		items: "inserttable link image kbModuleLink media",
	},
};

/** @type {import("tinymce").RawEditorSettings} */
const fullFatConfig = {
	plugins: [
		"advlist autolink link image lists charmap print preview hr anchor pagebreak",
		"searchreplace wordcount visualblocks visualchars code fullscreen media nonbreaking",
		"table paste help autoresize typekit quizlink kbModuleLink directionality",
	],
	menubar: "edit format insert view",
	contextmenu: "link image table paste",
	toolbar:
		"fullscreen | styleselect | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | ltr rtl",
	style_formats: styleFormats,
	paste_data_images: true,
	color_map: colors,
	custom_colors: false,
	advlist_bullet_styles: "default circle",
	advlist_number_styles: "default lower-alpha lower-roman",
	table_toolbar:
		"tableprops tabledelete | tablecellborderwidth tablecellborderstyle tablecellbordercolor tablecellbackgroundcolor | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",
	table_appearance_options: true,
	table_advtab: true,
	table_cell_advtab: false,
	table_row_advtab: false,
	table_border_widths: tableBorderWidth,
	table_border_styles: tableBorderStyles,
	table_background_color_map: tableBackgroundColors,
	table_border_color_map: tableBorderColors,
};

/** @type {Record<string, import("tinymce").RawEditorSettings>} */
const configs = {
	default: Object.assign({}, fullFatConfig, {
		menu: defaultMenu,
	}),
	print_and_newsletter: Object.assign({}, fullFatConfig, {
		menu: defaultMenuWithoutQuizlinkAndKbModuleLink,
	}),
	default_without_quizlink: Object.assign({}, fullFatConfig, {
		menu: defaultMenuWithoutQuizlinkAndKbModuleLink,
	}),
	default_with_kb_module_link: Object.assign({}, fullFatConfig, {
		menu: defaultMenuWithKbModuleLink,
	}),
	basic_text: {
		menubar: false,
		plugins: ["autoresize code image wordcount paste"],
		toolbar:
			"removeformat | styleselect | bold italic underline strikethrough | image code | undo redo",
		style_formats: styleFormats,
		paste_data_images: false,
	},
	minimal: {
		menubar: false,
		plugins: ["autoresize wordcount paste advlist lists preview"],
		toolbar:
			"removeformat | styleselect | bold italic underline strikethrough | bullist numlist | undo redo | preview",
		advlist_bullet_styles: "default circle",
		advlist_number_styles: "default lower-alpha lower-roman",
		style_formats: styleFormatsMinimal,
		paste_data_images: false,
	},
	minimal_in_game: {
		plugins: ["autoresize paste"],
		toolbar: "removeformat | bold italic underline strikethrough",
		paste_data_images: false,
	},
	publication: {
		block_unsupported_drop: false,
		paste_data_images: true,
		plugins: [
			"advlist autolink link image media lists preview hr",
			"fullscreen nonbreaking",
			"table autoresize paste wordcount",
		],
		menu: defaultMenuWithoutQuizlinkAndKbModuleLink,
		menubar: "edit format insert view",
		contextmenu: "link image table",
		toolbar:
			"fullscreen | styleselect | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent",
		color_map: colors,
		custom_colors: false,
		advlist_bullet_styles: "default circle",
		advlist_number_styles: "default lower-alpha lower-roman",
		table_toolbar:
			"tableprops tabledelete | tablecellborderwidth tablecellborderstyle tablecellbordercolor tablecellbackgroundcolor | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",
		table_appearance_options: false,
		table_advtab: true,
		table_cell_advtab: false,
		table_row_advtab: false,
		table_border_widths: tableBorderWidth,
		table_border_styles: tableBorderStyles,
		table_background_color_map: tableBackgroundColors,
		table_border_color_map: tableBorderColors,
	},
	answer_text: {
		paste_data_images: false,
		plugins: ["lists paste advlist table autoresize wordcount fullscreen"],
		style_formats: [
			{ title: "h1", format: "h1" },
			{ title: "h2", format: "h2" },
			{ title: "h3", format: "h3" },
			{ title: "Paragraph", format: "p" },
		],
		toolbar:
			"removeformat fullscreen | styleselect | bold italic underline | bullist numlist | table",
		advlist_bullet_styles: "default circle",
		advlist_number_styles: "default lower-alpha lower-roman",
		table_toolbar:
			"tableprops tabledelete | tablecellborderwidth tablecellborderstyle tablecellbordercolor tablecellbackgroundcolor | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",
		table_appearance_options: false,
		table_advtab: false,
		table_cell_advtab: false,
		table_row_advtab: false,
		table_border_widths: tableBorderWidth,
		table_border_styles: tableBorderStyles,
		table_background_color_map: tableBackgroundColors,
		table_border_color_map: tableBorderColors,
	},
	only_text_window: {
		toolbar: "",
		height: "492px", // Corresponds to the style of .Draft__text-block, 500px height - 8px padding
	},
};

/**
 * @param {Element} target
 * @returns {import("tinymce").RawEditorSettings}
 */
export default function tinyMCEConfigFor(target) {
	const mceInterface =
		$(target).closest("[data-mce-interface]").attr("data-mce-interface") ||
		"default";
	const mergedConfigs = Object.assign({}, commonConfig, configs[mceInterface]);
	return Object.assign({}, mergedConfigs, {
		content_css: additionalMceStylesheetPath(),
	});
}
